import styled from "styled-components";

export const StyledWrapper = styled.div`
  max-width: 90rem;
  margin: 0 auto;
  padding: 0 1rem;
`;
